import { useState } from 'react'
import { useQuery } from 'react-query'
import Skeleton from 'react-loading-skeleton'

import { logger } from '@services/logger'
import { createClient } from '@services/api'
import { ExploreResource } from '@models/explore'
import { ExploreDialog } from '@components/ExploreDialog'

export async function getExploreResources() {
  try {
    const { data } = await createClient().get('/explore')
    return data
  } catch (error) {
    logger.error(error)
    return []
  }
}

export function PublicExplore() {
  const [selectedResource, setSelectedResource] = useState<ExploreResource>()
  const { data, status } = useQuery<ExploreResource[]>(
    'explore',
    getExploreResources
  )

  return (
    <div className="grid lg:grid-cols-3 sm:grid-cols-2 md-grid-cols-1 gap-4 2xl:mx-48 xl:mx-24 mx-8 lg:mb-36 mb-12">
      <ExploreDialog
        resource={selectedResource}
        handleClose={() => setSelectedResource(undefined)}
      />

      {status === 'loading' && (
        <>
          <div className="col-span-1 bg-white rounded-lg hover:shadow-lg shadow-md lg:transform-gpu transition hover:scale-105 cursor-pointer">
            <Skeleton height={200} width="100%" />

            <div className="p-4">
              <Skeleton height={16} width={150} />
              <Skeleton height={16} width="100%" />
            </div>
          </div>
          <div className="col-span-1 bg-white rounded-lg hover:shadow-lg shadow-md lg:transform-gpu transition hover:scale-105 cursor-pointer">
            <Skeleton height={200} width="100%" />

            <div className="p-4">
              <Skeleton height={16} width={150} />
              <Skeleton height={16} width="100%" />
            </div>
          </div>

          <div className="col-span-1 bg-white rounded-lg hover:shadow-lg shadow-md lg:transform-gpu transition hover:scale-105 cursor-pointer">
            <Skeleton height={200} width="100%" />

            <div className="p-4">
              <Skeleton height={16} width={150} />
              <Skeleton height={16} width="100%" />
            </div>
          </div>
        </>
      )}

      {status === 'success' &&
        data?.map(resource => {
          return (
            <div
              className="col-span-1 bg-white rounded-lg hover:shadow-lg shadow-md lg:transform-gpu transition hover:scale-105 cursor-pointer"
              onClick={() => setSelectedResource(resource)}
              key={resource.id}
            >
              <img
                src={resource.image}
                className="w-full h-48 object-cover rounded-t-lg"
              />

              <div className="p-4">
                <h4 className="font-black text-lg leading-tight mb-2">
                  {resource.title}
                </h4>
                <p>{resource.summary}</p>
              </div>
            </div>
          )
        })}
    </div>
  )
}
